import { QueryClient, focusManager } from '@tanstack/react-query';

if (typeof window !== 'undefined') {
  focusManager.setFocused(true);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
    mutations: { networkMode: 'always' },
  },
});
